import { IAlertMessageProps, IPopupProps } from "component-library";
import { ReactNode } from "react";

export default class GlobalAlertMessage {
  public popupProps: IPopupProps;
  public alertMessageProps: IAlertMessageProps;
  public closeButton: { name: string; type: string; click?: () => void };
  public children?: ReactNode;
}
